export const watcherViewSample = {
    'id': 'metric_watch_01_7c4581a1-351d-413f-afc2-376f40603d20-2020-02-04T07:52:39.062486Z',
    'watchId': 'metric_watch_01',
    'triggeredTime': '2020-02-04T07:52:39.062474Z',
    'details': {
        '_shards': {
            'total': 1,
            'failed': 0,
            'successful': 1,
            'skipped': 0
        },
        'hits': {
            'hits': [
                {
                    '_index': 'metricbeat-7.5.2-2020.01.22-000001',
                    '_type': '_doc',
                    '_source': {
                        'cloud': {  },
                        'process': {  },
                        'agent': {  },
                        '@timestamp': '2020-01-23T02:36:00.122Z',
                        'system': {  },
                        'ecs': {  },
                        'service': {  },
                        'host': {  },
                        'metricset': {  },
                        'event': {  },
                        'user': {  }
                    },
                    '_id': '3Q1B0G8BRnkQUQTHpsav',
                    '_score': 1.0
                }
            ],
            'total': 1,
            'max_score': 1.0
        },
        'took': 3,
        'timed_out': false
    }
};

export const watcherSample = {
    'id': 'metric_watch_01_7c4581a1-351d-413f-afc2-376f40603d20-2020-02-04T07:52:39.062486Z',
    'watchId': 'metric_watch_01',
    'triggeredTime': '2020-02-04T07:52:39.062474Z',
    'details': '1, 0, 1, 0, metricbeat-7.5.2-2020.01.22-000001, _doc, 2020-01-23T02:36:00.122Z, 3Q1B0G8BRnkQUQTHpsav, 1.0, 1, 1.0, 3, false'
};




// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/watcher.ts